import { current } from "@reduxjs/toolkit";
import React, { useState } from "react";
import { TiDelete } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getTeamLead } from "store/teamLead/teamLeadThunk";
import { assignBots } from "store/teamLead/teamLeadThunk";
import { unassignAgent } from "store/teamLead/teamLeadThunk";
import { assignAgents } from "store/teamLead/teamLeadThunk";
import { unassignWorker } from "store/worker/workerThunk";
import { getUnassignedBots } from "store/worker/workerThunk";

const TeamLeadDetails = ({ toggleModal, unassignedAgents }) => {
  const { currentTeamLead } = useSelector((state) => state.team_lead) || [];
  const { unAssignedBots = [] } = useSelector((state) => state.worker) || {};
  const [, setUnassignedBot] = useState(unAssignedBots);

  const [assignedAgents, setAssignedAgents] = useState(
    currentTeamLead?.agents || []
  );

  const [assignedBots, setAssignedBots] = useState(
    currentTeamLead?.workers.filter(
      (worker) => worker.AssignedAgentId !== null
    ) || []
  );
  console.log(assignedAgents, "AssignedAgents");

  const [selectedAgent, setSelectedAgent] = useState("");
  const [selectedBot, setSelectedBot] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const dispatch = useDispatch();

  const handleAssignAgent = () => {
    if (selectedAgent) {
      const agent = unassignedAgents.find(
        (a) => a.Id === parseInt(selectedAgent)
      );
      if (agent && !assignedAgents.find((a) => a.Id === agent.Id)) {
        dispatch(
          assignAgents({
            agent_id: selectedAgent,
            teamLead_ID: currentTeamLead?.Id,
          })
        ).then(() => {
          dispatch(getTeamLead(currentTeamLead?.Id));
          setAssignedAgents([...assignedAgents, agent]);
        });
      }
      setSelectedAgent("");
    }
  };

  const handleUnassignAgent = async (id) => {
    try {
      // Dispatch unassignAgent to remove the agent from the team
      await dispatch(unassignAgent({ agent_id: id }));

      // Re-fetch the team lead data to get the updated list of assigned agents
      await dispatch(getTeamLead(currentTeamLead?.Id));

      // Remove the agent from the assigned agents list in the local state
      setAssignedAgents(assignedAgents.filter((agent) => agent.Id !== id));
    } catch (error) {
      // Show error toast if the unassignment fails
      const errorMessage =
        error?.response?.data?.details ||
        error.message ||
        "Something went wrong";
      toast.error(errorMessage);
    }
  };
  const handleAssignBot = () => {
    if (selectedBot) {
      const bot = unAssignedBots.find((b) => b.id === parseInt(selectedBot));
      if (bot && !assignedBots.find((b) => b.id === bot.id)) {
        setAssignedBots([...assignedBots, bot]);
        dispatch(
          assignBots({
            worker_id: selectedBot,
            user_id: currentTeamLead.Id,
          })
        ).then(() => {
          dispatch(getTeamLead(currentTeamLead.Id));
          dispatch(getUnassignedBots());
          setAssignedBots([...assignedBots, bot]);
          setTimeout(() => {
            setUnassignedBot(
              unAssignedBots.filter((b) => b.id !== parseInt(selectedBot))
            );
            setSelectedBot("");
          }, 500);
        });
      }
    }
  };

  const handleUnassignBot = (id) => {
    // Dispatch the unassignWorker action with the worker ID
    dispatch(unassignWorker({ worker_id: id }))
      .unwrap() // Unwraps the result to get the response or error
      .then((response) => {
        // On success, update the assigned bots list
        const updatedAssignedBots = assignedBots.filter((bot) => bot.Id !== id);
        setAssignedBots(updatedAssignedBots); // Update the state with the new list of assigned bots

        // Optionally, re-fetch the team lead data to get the updated list of assigned bots
        dispatch(getTeamLead(currentTeamLead?.Id)).then(() => {
          // Optional: You can also refresh the unassigned bots list if needed
          dispatch(getUnassignedBots());
        });

        // Display success toast
        toast.success("Bot successfully unassigned");
      })
      .catch((error) => {
        // On failure, display the error message as a toast
        toast.error(error?.message || "Failed to unassign bot");
      });
  };

  return (
    <div className="modal_overlay">
      <div className="modal_container ">
        <div className="modal-header w-[95%] mx-auto">
          <h2 className="modal-title">Team Lead Details</h2>
          <div className="flex justify-end items-end">
            <button onClick={toggleModal}>
              <TiDelete size={26} className="text-red-400 hover:text-red-600" />
            </button>
          </div>
        </div>
        <div className="p-7">
          <div className="flex items-center mb-6 ">
            <div>
              <h2 className="text-xl font-semibold">
                {currentTeamLead?.first_name} {currentTeamLead?.last_name}
              </h2>
              <p className="text-gray-500">{currentTeamLead?.Email}</p>
            </div>
          </div>

          {/* Tabs */}
          <div className="flex justify-center border-b border-gray-300 space-x-8 mb-6">
            <button
              className={`px-4 py-2 text-sm font-semibold focus:outline-none ${
                activeTab === "overview"
                  ? "border-b-2 border-blue-500 text-blue-500"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("overview")}
            >
              Overview
            </button>
            <button
              className={`px-4 py-2 text-sm font-semibold focus:outline-none ${
                activeTab === "agents"
                  ? "border-b-2 border-blue-500 text-blue-500"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("agents")}
            >
              Agents
            </button>
            <button
              className={`px-4 py-2 text-sm font-semibold focus:outline-none ${
                activeTab === "bots"
                  ? "border-b-2 border-blue-500 text-blue-500"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("bots")}
            >
              Bots
            </button>
          </div>

          {/* Tab Content */}
          <div className="mt-4">
            {activeTab === "overview" && (
              <div>
                <h3 className="text-lg font-semibold mb-4">Overview</h3>
                {/* Assigned Agents Tab */}
                <div className="mb-6">
                  <h4 className="text-md font-semibold text-blue-600 mb-2">
                    Agents
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {currentTeamLead?.agents.length > 0 ? (
                      currentTeamLead?.agents.map((agent) => (
                        <div
                          key={agent.Id}
                          className="relative flex items-center px-4 py-2 bg-blue-100 text-blue-600 rounded-full shadow-md text-sm"
                        >
                          {agent.first_name} {agent.last_name}
                          <button
                            onClick={() => handleUnassignAgent(agent.Id)}
                            className="absolute right-0 top-0 px-1 text-red-600 hover:text-red-700 text-lg"
                          >
                            ×
                          </button>
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-500">No agents assigned yet.</p>
                    )}
                  </div>
                </div>
                {/* Assigned Bots Tab */}
                <div>
                  <h4 className="text-md font-semibold text-green-600 mb-2">
                    Bots
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {currentTeamLead?.workers?.length > 0 ? (
                      currentTeamLead?.workers?.map((bot) => (
                        <div
                          key={bot.Id}
                          className="relative flex items-center px-4 py-2 bg-green-100 text-green-600 rounded-full shadow-md text-sm"
                        >
                          {bot.Name}
                          <button
                            onClick={() => handleUnassignBot(bot.Id)}
                            className="absolute right-0 top-0 px-1 text-red-600 hover:text-red-700 text-lg"
                          >
                            ×
                          </button>
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-500">No bots assigned yet.</p>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Assign Agents Tab */}
            {activeTab === "agents" && (
              <div>
                <h3 className="text-lg font-semibold mb-4"> Agents</h3>
                <div className="mb-6">
                  <div className="flex flex-wrap gap-2">
                    {currentTeamLead?.agents?.length > 0 ? (
                      currentTeamLead?.agents?.map((agent) => (
                        <div
                          key={agent.Id}
                          className="relative flex items-center px-4 py-2 bg-blue-100 text-blue-600 rounded-full shadow-md text-sm"
                        >
                          {agent.first_name} {agent.last_name}
                          <button
                            onClick={() => handleUnassignAgent(agent.Id)}
                            className="absolute right-0 top-0 px-1 text-red-600 hover:text-red-700 text-lg"
                          >
                            ×
                          </button>
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-500">No agents assigned yet.</p>
                    )}
                  </div>
                </div>
                <div>
                  <select
                    className="border border-gray-300 rounded-lg px-4 py-2 w-full"
                    value={selectedAgent}
                    onChange={(e) => setSelectedAgent(e.target.value)}
                  >
                    <option value="">Select an agent</option>
                    {unassignedAgents?.map((agent) => (
                      <option key={agent.Id} value={agent.Id}>
                        {agent.first_name} {agent.last_name}
                      </option>
                    ))}
                  </select>
                  <button
                    onClick={handleAssignAgent}
                    className="mt-2 w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                  >
                    Assign Agent
                  </button>
                </div>
              </div>
            )}

            {/* Assign Bots Tab */}
            {activeTab === "bots" && (
              <div>
                <h3 className="text-lg font-semibold mb-4"> Bots</h3>
                <div className="mb-6">
                  <div className="flex flex-wrap gap-2">
                    {currentTeamLead?.workers?.length > 0 ? (
                      currentTeamLead?.workers?.map((bot) => (
                        <div
                          key={bot.Id}
                          className="relative flex items-center px-4 py-2 bg-green-100 text-green-600 rounded-full shadow-md text-sm"
                        >
                          {bot.Name}
                          <button
                            onClick={() => handleUnassignBot(bot.Id)}
                            className="absolute right-0 top-0 px-1 text-red-600 hover:text-red-700 text-lg"
                          >
                            ×
                          </button>
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-500">No bots assigned yet.</p>
                    )}
                  </div>
                </div>
                <div>
                  <select
                    className="border border-gray-300 rounded-lg px-4 py-2 w-full"
                    value={selectedBot}
                    onChange={(e) => setSelectedBot(e.target.value)}
                  >
                    <option value="">Select a bot</option>
                    {unAssignedBots?.map((bot) => (
                      <option key={bot.id} value={bot.id}>
                        {bot.name}
                      </option>
                    ))}
                  </select>
                  <button
                    onClick={handleAssignBot}
                    className="mt-2 w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                  >
                    Assign Bot
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamLeadDetails;
